// Old trick to preserve line numbers
const noop = () => {};
export const log = window.location.search.match(/debug=ads/) ? console.debug.bind(window.console) : noop;
